import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-243">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-244">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-warmBrown-900/60 backdrop-blur-sm" onClick={onClose} data-id="element-245" />

          {/* Modal content */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} className="relative bg-white rounded-3xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col overflow-hidden border border-cream-200" data-id="element-246">
            {/* Header */}
            <div className="flex items-center justify-between px-8 py-5 border-b border-cream-200 shrink-0" data-id="element-247">
              <h3 className="text-2xl font-bold font-heading text-terracotta" data-id="element-248">
                {title}
              </h3>
              <motion.button whileHover={{
            scale: 1.1
          }} whileTap={{
            scale: 0.9
          }} onClick={onClose} className="w-10 h-10 rounded-full bg-cream-100 flex items-center justify-center text-warmBrown-600 hover:bg-cream-200 transition-colors" data-id="element-249">
                <X className="w-5 h-5" data-id="element-250" />
              </motion.button>
            </div>

            {/* Scrollable body */}
            <div className="overflow-y-auto px-8 py-6 text-warmBrown-800 leading-relaxed" data-id="element-251">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}